import { Box } from '@mui/system'
import React, { HTMLProps } from 'react'
import Modal from './Modal'
import theme from '../themes'
import { ThemeProvider } from '@mui/material'
import { colors } from '../themes/colors'

interface ImageWithPlaceholderProps extends HTMLProps<HTMLImageElement> {
  placeholderImageUrl: string
  size?: number
}

const handleImageError = (currentTarget: HTMLImageElement, placeholderImageUrl: string) => {
  currentTarget.onerror = null // prevents looping
  currentTarget.src = placeholderImageUrl
  currentTarget.style.cursor = 'default'
}

export const ImageWithPlaceholder = ({
  placeholderImageUrl,
  ...rest
}: ImageWithPlaceholderProps) => {
  const [isZoomed, setIsZoomed] = React.useState(false)
  const [error, setError] = React.useState<string | undefined>(undefined)

  const ref = React.useRef<HTMLImageElement>(null)

  const handleZoomIn = (e: React.KeyboardEvent<HTMLImageElement>) => {
    if (e.key === ' ' || e.key === 'Enter') {
      setIsZoomed(true)
    }
  }

  const handleZoomOut = () => {
    setIsZoomed(false)
  }

  const memo = React.useMemo(() => {
    return (
      <>
        <img
          ref={ref}
          key={rest.src}
          style={{
            cursor: 'zoom-in',
            width: rest.size ? rest.size / 2 : 'unset',
            background: colors.grey100,
            // height: rest.size ? rest.size / 2 : 'unset',
          }}
          onKeyDownCapture={handleZoomIn}
          onClick={() => setIsZoomed(true)}
          onKeyDown={() => setIsZoomed(true)}
          onError={({ currentTarget }) => {
            setError('Image not found')
            handleImageError(currentTarget, placeholderImageUrl)
          }}
          role='presentation'
          alt={rest.alt}
          {...rest}
          src={rest.src + `&w=0&h=${rest.size ?? 400}&q=100&m=6&f=jpg`}
        />

        <ThemeProvider theme={theme()}>
          <Modal handleClose={handleZoomOut} open={!error && isZoomed}>
            <Box onClick={handleZoomOut} style={{ display: 'flex' }} component={'a'}>
              <img
                width={720}
                height={720}
                ref={ref}
                key={rest.src}
                style={{
                  cursor: 'zoom-out',
                  width: '100%',
                  height: '100%',
                }}
                onClick={handleZoomOut}
                onKeyDown={handleZoomOut}
                onError={({ currentTarget }) =>
                  handleImageError(currentTarget, placeholderImageUrl)
                }
                alt={rest.alt}
                {...rest}
                src={rest.src + '&w=0&h=720'} // Use the 'end' variable here
              />
            </Box>
          </Modal>
        </ThemeProvider>
      </>
    )
  }, [isZoomed, rest.src]) // Add 'end' to the dependency array

  return memo
}

export default ImageWithPlaceholder
